import type { ReactNode } from 'react';
import { Link } from '@tanstack/react-router';
import { PageBody, TabList, tabVariants } from '@wundo/ui';
import { PageHeader } from '@/components/PageHeader.tsx';

/* The tabs are routes, so each has its own URL and a sent notification opens under History. */
const TABS = [
  { key: 'send', to: '/admin/notifications', label: 'Send' },
  { key: 'history', to: '/admin/notifications/history', label: 'History' },
] as const;

export type NotificationsTabKey = (typeof TABS)[number]['key'];

/**
 * Everything Wundo says to somebody without being asked: send one of its
 * notifications or mails by hand, or look back at what was sent and what each
 * person received. A mail is a notification that only goes by email.
 */
export function NotificationsLayout({
  active,
  children,
}: {
  active: NotificationsTabKey;
  children: ReactNode;
}) {
  return (
    <>
      <PageHeader
        title='Notifications'
        subtitle='Send a notification to one person, an organisation or a cohort, and see what Wundo sent.'
      />
      <PageBody className='flex flex-col gap-5.5'>
        <TabList>
          {TABS.map((tab) => (
            <Link
              key={tab.key}
              to={tab.to}
              role='tab'
              aria-selected={active === tab.key}
              className={tabVariants({ active: active === tab.key })}
            >
              {tab.label}
            </Link>
          ))}
        </TabList>

        {children}
      </PageBody>
    </>
  );
}
